import { colors } from '../../colors';
var address = {
  addressColor: colors.slateGrey
};
export default address;